/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default [
	// {
	// 	name: "Tổng quan",
	// 	slug: "Dashboard",
	// 	icon: "nucleo nucleo-users-mm",
	// 	i18n: "Tổng quan",
	// 	featherIcon: false,
	// 	iconPack: "nucleo",
	// 	url: "/"
	// },
	{
		name: "Đăng bán",
		slug: "Tokhai",
		icon: "nucleo nucleo-configuration-tools",
		iconPack: "nucleo",
		i18n: "Đăng bán",
		featherIcon: false,
		// url: "/",
		url: "/pages/login",
	},
	{
		name: "Đăng ký thành viên",
		slug: "Product",
		icon: "nucleo nucleo-configuration-tools",
		iconPack: "nucleo",
		i18n: "Đăng ký thành viên",
		featherIcon: false,
		url: "/pages/register",
	},
	{
		name: "Vận đơn",
		slug: "Product",
		icon: "nucleo nucleo-configuration-tools",
		iconPack: "nucleo",
		i18n: "Vận đơn",
		featherIcon: false,
		url: "/shipping-review",
	},
	{
		name: "Các lệnh bán",
		slug: "Sells",
		icon: "nucleo nucleo-configuration-tools",
		iconPack: "nucleo",
		i18n: "Các lệnh bán",
		featherIcon: false,
		url: "/cac-lenh-ban",
	},
	{
		name: "Trang chủ",
		slug: "Trangchuthungan",
		icon: "nucleo nucleo-configuration-tools",
		iconPack: "nucleo",
		i18n: "Trang chủ",
		featherIcon: false,
		url: "/shipping-overview",
	},
	{
		name: "Thống kê",
		slug: "Dashboardthungan",
		icon: "nucleo nucleo-configuration-tools",
		iconPack: "nucleo",
		i18n: "Thống kê",
		featherIcon: false,
		url: "/shipping-dashboard",
	},
	// {
	// 	name: "NV Vùng cấp 1",
	// 	slug: "Tokhai",
	// 	icon: "nucleo nucleo-configuration-tools",
	// 	iconPack: "nucleo",
	// 	i18n: "NV Vùng cấp 1",
	// 	featherIcon: false,
	// 	url: "/nhan-vien-c1"
	// },
	// {
	// 	name: "NV Vùng cấp 2",
	// 	slug: "Tokhai",
	// 	icon: "nucleo nucleo-configuration-tools",
	// 	iconPack: "nucleo",
	// 	i18n: "NV Vùng cấp 2",
	// 	featherIcon: false,
	// 	url: "/nhan-vien-c2"
	// },
	// {
	// 	name: "NV Vùng cấp 3",
	// 	slug: "Tokhai",
	// 	icon: "nucleo nucleo-configuration-tools",
	// 	iconPack: "nucleo",
	// 	i18n: "NV Vùng cấp 3",
	// 	featherIcon: false,
	// 	url: "/nhan-vien-c3"
	// },
	// {
	// 	name: "NV Vùng cấp 4",
	// 	slug: "Tokhai",
	// 	icon: "nucleo nucleo-configuration-tools",
	// 	iconPack: "nucleo",
	// 	i18n: "NV Vùng cấp 4",
	// 	featherIcon: false,
	// 	url: "/nhan-vien-c4"
	// },
	// {
	// 	name: "Cần hỗ trợ",
	// 	slug: "Tokhai",
	// 	icon: "nucleo nucleo-configuration-tools",
	// 	iconPack: "nucleo",
	// 	i18n: "Cần hỗ trợ",
	// 	featherIcon: false,
	// 	url: "/can-ho-tro"
	// }

	// {
	// 	name: "Maps",
	// 	slug: "Maps",
	// 	icon: "nucleo nucleo-configuration-tools",
	// 	iconPack: "nucleo",
	// 	i18n: "Maps",
	// 	featherIcon: false,
	// 	url: "/dashboard/maps"
	// },
	// {
	// 	name: "Tracking",
	// 	slug: "dashboard-tracking",
	// 	icon: "nucleo nucleo-configuration-tools",
	// 	iconPack: "nucleo",
	// 	i18n: "Tracking",
	// 	featherIcon: false,
	// 	url: "/dashboard/tracking"
	// }
];
